<template>
  <section class="stock_list_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row mb-3">
      <div class="col-12">
        <b-btn
          variant="primary"
          size="md"
          class="float-right"
          :to="'/mappings/add'"
          >Add New Mapping</b-btn
        >
      </div>
    </div>

    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="3" class="my-1">
        <b-form-group horizontal label="Per page" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-table
      show-empty
      v-if="items"
      stacked="md"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template slot="cell(actions)" slot-scope="row">
        <b-btn
          class="ml-2"
          size="sm"
          variant="warning"
          :to="`/mappings/${row.item.stock_to_ebay_id}/edit`"
          >Edit</b-btn
        >
        <b-btn
          class="ml-2"
          size="sm"
          variant="danger"
          @click="deleteConfirm(row.item.stock_to_ebay_id)"
          >Delete</b-btn
        >
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
export default {
  name: "mappings",
  mounted: function() {
    this.getMappings();
  },
  data() {
    return {
      mappings: [],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Mappings", active: true }
      ],
      fields: [
        {
          key: "ebay_model",
          label: "Ebay Model",
          sortable: true,
          sortDirection: "desc",
          class: "model-cell"
        },
        {
          key: "stock_model",
          label: "Stock Model",
          sortable: true,
          sortDirection: "desc",
          class: "model-cell"
        },
        {
          key: "brand",
          label: "Brand",
          sortable: true,
          sortDirection: "desc",
          class: "model-cell"
        },
        { key: "actions", label: "Actions", class: "text-center actions-col" }
      ],
      items: null,
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      pageOptions: [25, 50, 100, 200],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null
    };
  },
  methods: {
    deleteConfirm(stock_to_ebay_id) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to delete this mapping?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.deleteMapping(stock_to_ebay_id);
        }
      });
    },
    deleteMapping(stock_to_ebay_id) {
      let loader = this.$loading.show();
      this.$http
        .delete(this.APIURL + this.BRAND + "/mappings/" + stock_to_ebay_id)
        .then(
          () => {
            this.getMappings();
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    getMappings() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/mappings").then(
        response => {
          this.items = response.data;
          this.totalRows = this.items.length;
          loader.hide();
        },
        error => {
          console.log(error);
        }
      );
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>
